<script>
    import {onMount} from "svelte";
    import {API_URL} from "../../../env";
    import {showDialogLogin} from "../../js/stores";
    import {querystring} from "svelte-spa-router";
    import Error from "../../placeholders/Error.svelte";
    import Loading from "../../placeholders/ProductsLoading.svelte";
    import NotFound from "../../placeholders/NotFound.svelte";

    window.scrollTo(0, 0);

    showDialogLogin.set({show: false, type: "", data: {}})

    // export let params = {}
    $: state = "loading"

    onMount(async () => {
        const urlParams = new URLSearchParams($querystring)

        if (!urlParams.has("t")) {
            return state = "no-token"
        }

        const body = {
            token: urlParams.get("t")
        }

        const res = await fetch(API_URL+'/users/verify', {
            method: 'PUT',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        })



        if (res.status === 200) {
            return state = "done"
        }
        else if (res.status === 202) {
            return state = "already-verified"
        }
        else {
            return state = "error"
        }
    })

    function handleOpenLogin() {
        showDialogLogin.set({show: true, type: "login", data: {}})
    }
</script>

<section class="error-page">
    <div class="row">
        <div class="col-12">
            {#if state === "loading"}
                <Loading title = "Pracujem na odoslaní overovacieho e-mailu..."/>
            {:else if state === "done"}
                <div class="loading-page">
                    <i class="fa-regular fa-circle-check"></i>
                    <h3>Účet úspešne overený.</h3>
                    <p>Teraz sa môžete <a on:click={handleOpenLogin} style="cursor: pointer">prihlásiť</a>.</p>
                </div>
            {:else if state === "already-verified"}
                <div class="loading-page">
                    <i class="fa-regular fa-circle-check"></i>
                    <h3>Účet už je overený.</h3>
                    <p class="margin-top">Skúste sa <a on:click={handleOpenLogin} style="cursor: pointer">prihlásiť</a>.</p>
                </div>
            {:else if state === "no-token"}
                <NotFound title="Nie je možné overiť žiadny účet, chýba overovací token."/>
            {:else}
                <Error
                    title="Niekde nastala chyba."
                    text="Táto chyba môže byť spôsobená vypršaním časového limitu tohto odkazu. Pre obdržanie nového odkazu sa prihláste a postupujte podľa následne zobrazených pokynov."
                />
            {/if}
        </div>
    </div>
</section>

<style>
    .margin-top {
        margin-top: 0.5rem;
    }
</style>

